import { Header, Paragraph } from "@datagame/ui";
import { useTranslation } from "react-i18next";

import { Content } from "./Content";
import { ProjectForReport } from "../ReportView";

import styles from "./ShareSection.module.scss";

export interface ShareSectionProps {
  project: ProjectForReport;
}

export const ShareSection = ({ project }: ShareSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.shareSection}>
      <div className={styles.shareHeaderWrapper}>
        <Header variant="h5">{t("report:shareOptions")}</Header>
        <Paragraph color="secondary" size="small">
          {t("report:shareOptionsDescription")}
        </Paragraph>
      </div>

      <Content project={project} />
    </div>
  );
};
